<template>
  <div>
    <b-loading
        v-model="isLoading"
        :can-cancel="true"
        :is-full-page="true"
    ></b-loading>
    <editProfile :isEditProfileActive="isEditProfileActive"
                 @editProfileStatus="isEditProfileActive = false"></editProfile>
    <div style="display: flex; margin-top: 16px">
      <div class="media mr-4" v-if="user != null">
        <avatar :user="user"></avatar>
        <div class="media-content" style="margin-left: 8px; margin-top: 12px;">
          <h6 class="is-6 has-text-weight-semibold" style="margin-bottom: 0; line-height: 0.5;">{{ user.fullName }}</h6>
          <small class="is-size-7 has-text-grey-light" style="white-space: nowrap">{{ user.email }}</small>
        </div>
      </div>
      <b-navbar-dropdown :collapsible="true" :boxed="true" style="margin-right: 16px;" :right="true">
        <b-navbar-item @click="onChangePassword">
          Update password
        </b-navbar-item>
        <b-navbar-item @click="onChangeProfile">
          Change profile
        </b-navbar-item>
        <b-navbar-item v-if="isMfaDisabled" @click="onActivateMFA">
          Activate MFA
        </b-navbar-item>
        <b-navbar-item @click="logout">
          Logout
        </b-navbar-item>
      </b-navbar-dropdown>
    </div>
  </div>
</template>

<script>
import editProfile from '@/components/edit-profile/edit-profile'
import avatar from "@/components/avatar/avatar.vue";
import Vue from "vue";

export default {
  name: "user-dropdown",
  components: {
    editProfile,
    avatar
  },
  data() {
    return {
      isEditProfileActive: false,
      isLoading: false,
      isMfaDisabled: false
    }
  },
  mounted() {
    this.isMfaDisabled = this.$store.state.user.preferredMFA === 'NOMFA'
  },
  computed: {
    user() {
      return {
        avatar: null,
        fullName: this.$store.getters.getUserFullName,
        job: this.$store.getters.getUserRole,
        email: this.$store.getters.getUserEmail
      }
    }
  },
  methods: {
    async logout() {
      this.isLoading = true
      await this.$auth.signOut().then(() => {
        this.$router.push('/')
        this.$store.dispatch('clearAllUserData')
      })
      this.isLoading = false
    },
    onChangePassword() {
      let url = Vue.prototype.$env.VUE_APP_AUTH_URL + '/change-password?name=Safety'
      window.location.replace(url)
    },
    onChangeProfile() {
      let url = Vue.prototype.$env.VUE_APP_AUTH_URL + '/change-profile?name=Safety'
      window.location.replace(url)
    },
    onActivateMFA() {
      if (this.$store.getters.getUserPhone && this.$store.getters.getUserPhone.length > 0) {
        let url = Vue.prototype.$env.VUE_APP_AUTH_URL + '/activate-mfa?name=Safety'
        window.location.replace(url)
      } else {
        this.$buefy.toast.open(
            {
              duration: 5000,
              message: 'To activate Multi Factor Authorisation first set phone number for your profile. Go to Change Profile and set phone number.'
            }
        )
      }
    }
  }
}
</script>

<style scoped>

</style>